<template>
  <div style="width: 100%;height: 100%">
    <el-row type="flex" class="row-bg" justify="end" style="width: 100%; flex-wrap: wrap;">
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="payablePrint"
        v-if="USE_PRINT_TEMPLATE == 0" v-show="printStatus === 1 && companyID !== 100">
        抬头打印
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="preview(1)"
        v-if="USE_PRINT_TEMPLATE == 0" v-show="printStatus === 1 && companyID !== 100">
        打印预览
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="printChecked"
        v-show="companyID !== 100">
        打印勾选项
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewSpecial"
        v-if="USE_PRINT_TEMPLATE == 0" v-show="printStatus === 1">
        打印五联单
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="websitePricePrint"
        v-if="USE_PRINT_TEMPLATE == 0" v-show="fun_dic[100060201]">
        对标网站价格打印
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewPrint"
        v-if="USE_PRINT_TEMPLATE == 1">
        打印预览
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="addOutWare"
        v-if="fun_dic[100060203]">
        补出库
      </el-button>
    </el-row>
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ titleData[0].ADDRESS }}</li>
          <li><span>送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ titleData[0].TOTAL_SUPPLIER_FEE }}</li>
          <li><span>订单备注</span>：{{ titleData[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ titleData[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ titleData[0].TELPHONE }}</li>
          <li><span>订单编号</span>：{{ titleData[0].ORDER_CODE }}</li>
          <li><span>实收总金额</span>：{{ titleData[0].REAL_TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号" min-width="150"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="单价（元）" v-if="canSupplierAdjustPrice">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ADJUST_PRICE" :placeholder="scope.row.REAL_PRICE"
                @change="adjustPriceChange(scope.row)">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）" v-else></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="REASON" label="退货原因"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button v-if="titleData[0].STATUS > 3" type="text" size="small" @click="downloadBatchReport(scope.row)"
                :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-button size="small" style="float: right; margin-top: 10px;" @click="submitPriceAdjustment"
        v-if="canSupplierAdjustPrice" v-show="fun_dic[100060202]">
        提交价格修改申请
      </el-button>
    </el-row>
    <el-row :data="titleData">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="statusFlag" finish-status="success" v-show="statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <!-- 打印设置 -->
    <!-- 打印显示送货数量还是订购数量 -->
    <el-dialog title="打印项" center :visible.sync="printSetFormVisible" width="600px">
      <el-form>
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-radio v-model="printRadio" label="0">订购数量</el-radio>
          <el-radio v-model="printRadio" label="1">送货数量</el-radio>
        </el-form-item>
        <el-form-item label="单据类型：" :label-width="formLabelWidth">
          <el-radio v-model="docTypeRadio" label="0">长单子</el-radio>
          <el-radio v-model="docTypeRadio" label="1">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint">打印</el-button>
      </div>
    </el-dialog>
    <!-- 勾选打印 -->
    <el-dialog title="勾选打印项" center :visible.sync="printCheckedFormVisible" width="400px">
      <el-form>
        <el-form-item label="打印类型：" :label-width="formLabelWidth">
          <el-radio v-model="printCheckedRadio" label="0">订购数量</el-radio>
          <el-radio v-model="printCheckedRadio" label="1">送货数量</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printCheckedFormVisible = false">取 消</el-button>
        <el-button @click="previewChecked">打印</el-button>
      </div>
    </el-dialog>
    <!-- 抬头打印 -->
    <el-dialog title="抬头信息" center :visible.sync="payableFormVisible" width="600px">
      <el-form :model="payableForm" ref="payableForm">
        <el-form-item label="抬头信息：" :label-width="formLabelWidth">
          <el-input v-model="payableForm.NAME"></el-input>
        </el-form-item>
        <el-form-item label="打印类型：" :label-width="formLabelWidth">
          <el-radio v-model="payableForm.TYPE" label="1">短打印</el-radio>
          <el-radio v-model="payableForm.TYPE" label="2">长打印</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePayable">取 消</el-button>
        <el-button @click="submitPayable">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="打印预览" center :visible.sync="productionDateOnlineDialog" width="600px" @close="cancelPreviewPrint">
      <el-form :model="productionDateOnlineForm" ref="productionDateOnlineForm">
        <el-form-item label="生产日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="productionDateOnlineForm.PRODUCTION_DATE" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" clearable style="width: 100% !important;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="productionDateOnlineDialog = false">取 消</el-button>
        <el-button @click="() => {
          switch (productionDateOnlineForm.type) {
            case '模板打印':
              submitPreviewPrint();
              break;
            case '勾选打印':
              submitPrintChecked();
              break;
            default:
          }
        }">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { orderConfirmDetailFun } from 'api/sellOrder';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import { downloadBatchReport } from '@/assets/api/shopOrderManage';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

export default {
  data () {
    return {
      fromName: ['websitePricePrint', 'sellOrderFivePrint', 'sellOrderPrint', 'sellAllOrderPrint', 'sellOrderCustomPrintDetail', 'AllOrderList', 'complementOutWarehouse'],
      toName: ['websitePricePrint', 'sellOrderFivePrint', 'sellOrderPrint', 'sellAllOrderPrint', 'sellOrderCustomPrintDetail', 'complementOutWarehouse'],
      managername: sessionStorage.getItem('name'),
      tableData: [],
      titleData: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      USE_PRINT_TEMPLATE: 0,
      printStatus: '',
      formLabelWidth: '100px',
      checkData: [],
      statusFlag: 0,
      companyID: Number(sessionStorage.getItem('tcid')),
      orderID: Number(sessionStorage.getItem('orderId')),
      checkedArray: [],
      returnVisible: false,
      returnList: [],
      printSetFormVisible: false,
      printRadio: '0',
      docTypeRadio: '0',
      selectionList: [],
      payableFormVisible: false,
      payableForm: {
        TYPE: '1',
      },
      payableName: '',
      printCheckedFormVisible: false,
      printCheckedRadio: '0',
      PAGE_ID: '1000602', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100060201: 0,
        100060202: 0,
        100060203: 0,
      },
      canSupplierAdjustPrice: false,
      productionDateOnlineDialog: false,
      productionDateOnlineForm: {
        PRODUCTION_DATE: '',
        type: '',
      },
      templateContent: [],
    };
  },
  methods: {
    // 抬头打印
    payablePrint () {
      this.payableFormVisible = true;
    },
    closePayable () {
      this.payableFormVisible = false;
      this.payableForm = {};
    },
    submitPayable () {
      if (this.payableForm.NAME) {
        this.payableName = this.payableForm.NAME;
        sessionStorage.setItem('payableName', this.payableName);
      } else {
        this.$message.show({ text: '请输入抬头信息', type: 'warning' });
        return;
      }
      if (this.payableForm.TYPE === '1') {
        this.$router.push({ name: 'sellOrderPrint', params: { remarks: 1 } });
        sessionStorage.setItem('countFlag', 1);
        sessionStorage.setItem('isShortDocFlag', 1);
        sessionStorage.setItem('printRealFlag', 0);
      } else if (this.payableForm.TYPE === '2') {
        this.preview();
      }
    },
    // 改变表格字体颜色
    tableRowClassName ({ row }) {
      if (Number(row.PRODUCT_COUNT) !== Number(row.REAL_COUNT)) {
        return 'warning-row';
      }
      return '';
    },
    queryForm () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID: this.titleData[0].TC_ID,
      };
      http.post(params).then((result) => {
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
        this.templateContent = result[0].TEMPLATE_CONTENT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    previewPrint () {
      if (this.templateContent[0] && this.templateContent[0].tableSet.includes('生产日期(线上填写)')) {
        this.productionDateOnlineDialog = true;
        this.productionDateOnlineForm.type = '模板打印';
      } else this.submitPreviewPrint();
    },
    submitPreviewPrint () {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateOnlineForm.PRODUCTION_DATE);
      sessionStorage.setItem('TEM_TCID', this.titleData[0].TC_ID);
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
    },
    cancelPreviewPrint () {
      this.$refs.productionDateOnlineForm.resetFields();
    },
    // -----------------------------------进入页面拉取数据
    queryOrderDetailListData () {
      const params = {
        ORDER_ID: this.orderID,
      };
      orderConfirmDetailFun(params).then((result) => {
        if (result[0].length !== 0) {
          this.tableData = result.length > 0 ? result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) })) : [];
          this.titleData = result.length > 0 ? result[0].TITLE : [];
          this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          this.printStatus = result[0].PRINT_FLAG;
          this.queryForm();
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
        } else {
          this.tableData = [];
        }
        this.getCanSupplierAdjustPrice();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 勾选打印
    printChecked () {
      if (this.USE_PRINT_TEMPLATE == 1) {
        if (this.selectionList.length !== 0) {
          if (this.templateContent[0] && this.templateContent[0].tableSet.includes('生产日期(线上填写)')) {
            this.productionDateOnlineDialog = true;
            this.productionDateOnlineForm.type = '勾选打印';
          } else this.submitPrintChecked();
        } else {
          this.$message.show({ text: '请进行勾选', type: 'warning' });
        }
      } else {
        this.printCheckedFormVisible = true;
      }
    },
    submitPrintChecked () {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateOnlineForm.PRODUCTION_DATE);
      this.productionDateOnlineDialog = false;
      sessionStorage.setItem('selectionList', JSON.stringify(this.selectionList));
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
      sessionStorage.setItem('countFlag', this.printCheckedRadio);// 0表示打印订购数量,1表示打印送货数量
      sessionStorage.setItem('isShortDocFlag', 0);
      sessionStorage.setItem('printRealFlag', 0);
      sessionStorage.setItem('TEM_TCID', this.titleData[0].TC_ID);
    },
    previewChecked () {
      if (this.selectionList.length !== 0) {
        sessionStorage.setItem('selectionList', JSON.stringify(this.selectionList));
        this.$router.push({ name: 'sellAllOrderPrint', params: { fromAllOrder: 1 } });
        sessionStorage.setItem('countFlag', this.printCheckedRadio);// 0表示打印订购数量,1表示打印送货数量
        sessionStorage.setItem('isShortDocFlag', 0);
        sessionStorage.setItem('printRealFlag', 0);
      } else {
        this.$message.show({ text: '请进行勾选', type: 'warning' });
      }
    },
    // fromAllOrder 为 1 表示「全部订单详情」入口（该入口的非模板打印抬头按设置项取供应商名称）
    preview (fromAllOrder) {
      this.$router.push({ name: 'sellOrderPrint', params: fromAllOrder === 1 ? { fromAllOrder: 1 } : {} });
      sessionStorage.setItem('countFlag', 0);// 0表示打印订购数量,1表示打印送货数量
      sessionStorage.setItem('isShortDocFlag', 0);
      sessionStorage.setItem('printRealFlag', 0);
    },
    submitPrint () {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', this.printRadio);
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadio);
      sessionStorage.setItem('printRealFlag', 0);
    },
    handleSelectionChange (val) {
      this.selectionList = [];
      this.selectionList = val;
    },
    // 平昌的特殊形式打印
    previewSpecial () {
      this.$router.push({ name: 'sellOrderFivePrint' });
    },
    // 下载批次报告
    downloadBatchReport ({ BATCH_REPORT_ID }) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((res) => {
        if (res[0]) {
          window.location.href = util.getURLLocalHost(res[0].FILE_URL);
        }
      });
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    websitePricePrint () {
      const params = {
        SERVICE_ID: '10051',
        OTYPE: 11,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.$prompt('', '请输入乘算比例(%)', {
          confirmButtonText: '确定', cancelButtonText: '取消', inputValue: sessionStorage.getItem('websitePriceRate') ? sessionStorage.getItem('websitePriceRate') : '', center: true,
        }).then(({ value }) => {
          if (/(^([1-9]\d*)$)/.test(value)) {
            this.$router.push({ name: 'websitePricePrint' });
            sessionStorage.setItem('countFlag', 0); // 0表示打印订购数量,1表示打印送货数量
            sessionStorage.setItem('isShortDocFlag', 0);
            sessionStorage.setItem('printRealFlag', 0);
            sessionStorage.setItem('websitePriceRate', value);
          } else {
            this.$message.show({ text: '请输入正整数', type: 'warning' });
          }
        }).catch((e) => { });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    getCanSupplierAdjustPrice () {
      const params = {
        SERVICE_ID: '10260',
        OTYPE: 8,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.titleData[0].TC_ID,
      };
      http.post(params).then((res) => {
        this.canSupplierAdjustPrice = Boolean(res[0].CAN_ADJUST_PRICE);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    adjustPriceChange (row) {
      if (!validation.价格正数0验证(row.ADJUST_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        row.ADJUST_PRICE = '';
      }
    },
    submitPriceAdjustment () {
      const ORDER_DETAIL = [];
      for (const [index, row] of this.tableData.entries()) {
        if (row.ADJUST_PRICE) {
          if (!validation.价格正数0验证(row.ADJUST_PRICE)) {
            this.$message.show({ text: `第${index + 1}行输入的价格不正确，请重新输入`, type: 'warning' });
            return false;
          }
          ORDER_DETAIL.push({
            DETAIL_ID: row.ORDER_DETAIL_ID,
            TYPE_UNIT: row.TYPE_UNIT,
            ADJUST_PRICE: row.ADJUST_PRICE,
            PRODUCT_CODE: row.PRODUCT_CODE,
          });
        }
      }
      if (!ORDER_DETAIL.length) {
        this.$message.show({ text: '请修改价格后提交', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10260',
        OTYPE: 2,
        ORDER_ID: this.orderID,
        ORDER_DETAIL,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '调整成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    qr ({ ORDER_DETAIL_ID }) {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 43,
        DETAIL_ID: ORDER_DETAIL_ID,
      };
      http.post(params).then((res) => {
        if (res[0]) window.open(this.$util.getURLLocalHost(res[0]));
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    addOutWare () {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      if (this.selectionList.length !== 0) {
        this.$router.push({ name: 'complementOutWarehouse', params: { ProductList: this.selectionList, ORDER_ID: this.orderID } });
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从全部订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryOrderDetailListData();
        that.queryBeforeFun();
      }
    });
  },
};
</script>
<style scoped>
.el-table>>>.warning-row {
  color: rgb(245, 108, 108);
}

.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/allOrderDetail.vue